import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthguardService } from './services/authguard/authguard.service';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'onboarding',
    pathMatch: 'full'
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./mvp/onboarding/onboarding.module').then(m => m.OnboardingPageModule)
  },

  {
    path: 'tabs-page',
    canActivate: [AuthguardService],
    loadChildren: () => import('./mvp/tabs-page/tabs-page.module').then(m => m.TabsPagePageModule)
  },
  {
    path: 'rootTabs',
    canActivate: [AuthguardService],
    loadChildren: () => import('./shared/tabs/tabs.module').then(m => m.TabsPageModule)
  },

];


@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
